import { useEffect, useState } from "react";
import { BrandingItems } from "../../../../../@types/brandingItems.types";
import { UploadBrandingProps } from "../../../../../@types/components/uploadAdministrationProps.types";

import "./uploadBranding.css";

const UploadBranding = ({ branding, handleBrandingDelete, handleFileChange }: UploadBrandingProps): JSX.Element => {
	const [brandingItems, setBrandingItems] = useState<BrandingItems[]>([]);

	useEffect(() => {
		if (branding) {
			const { logo, favicon } = branding;
			setBrandingItems([
				{
					buttonCaption: "Logo",
					handleFileChange,
					file: logo,
					handleBrandingDelete,
					name: "logo"
				},
				{
					buttonCaption: "Favicon",
					handleFileChange,
					file: favicon,
					handleBrandingDelete,
					name: "favicon"
				}
			]);
		}
	}, [branding, handleFileChange, handleBrandingDelete]);

	return (
		<div className="upload-branding">
			<div></div>
		</div>
	);
};

export default UploadBranding;
